import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import generalPOST from "../../services/generalPOST";
import Navbar from "../../components/layout/Navbar";

/**
 * React component used for managing the "Forgot password" functionality.
 * Accessed from the SignIn page when a user presses "Glömt lösenord?".
 * @returns {JSX.Element}
 * @constructor
 */
const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [payload, setPayload] = useState("");
    const history = useHistory();

    const HandleSubmit = async (event) => {
        event.preventDefault();
        let promise = null;

        let response;

        promise = generalPOST(`${process.env.REACT_APP_API_URL}/api/forgot_password`, { email: email });

        promise
            .then((res) => {
                response = res;
                if (!res.ok) {
                    res.text().then((x) => console.log(x));
                }
                return res.text();
            })
            .then((data) => {
                if (response.status === 200) {
                    setPayload(data);
                }
            })
            .catch((err) => {
                switch (err.name) {
                    case "AbortError":
                        console.log("post aborted in ForgotPassword");
                        break;
                    default:
                        console.error(err.message);
                        break;
                }
            });
    };

    return (
        <div className="min-h-screen bg-sage font-body pt-16">
            
            <Navbar />

            <div className="flex items-center justify-center min-h-[calc(100vh-4rem)] p-4">
                <div className="w-full md:max-w-md bg-offwhite md:shadow-lg md:rounded-lg overflow-hidden">
                
                {/* Form Section */}
                <div className="w-full bg-offwhite flex items-center justify-center">
                    <div className="w-full max-w-md px-6 py-8">
                        <div className="flex flex-col items-center">
                            {/* Lock Icon */}
                            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-forest mb-4">
                                <svg className="w-6 h-6 text-offwhite" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                </svg>
                            </div>
                            
                            <h1 className="text-2xl font-heading font-semibold text-charcoal mb-6">
                                Glömt lösenord
                            </h1>
                            
                            <div className="w-full">
                                <div className="mb-4">
                                    <label htmlFor="email" className="block text-sm font-medium text-charcoal mb-1">
                                        E-postadress *
                                    </label>
                                    <input
                                        type="text"
                                        id="email"
                                        name="email"
                                        required
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="w-full px-3 py-2 border border-sage rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-forest focus:border-forest bg-white"
                                    />
                                </div>

                                {!payload && (
                                    <button
                                        type="submit"
                                        onClick={(e) => HandleSubmit(e)}
                                        className="w-full bg-leaf text-offwhite py-2 px-4 rounded-md hover:bg-forest transition-colors duration-200 mb-4 font-medium"
                                    >
                                        Återställ lösenord
                                    </button>
                                )}

                                {payload && (
                                    <div className="my-4 p-4 bg-sage rounded-md">
                                        <p className="text-center text-charcoal">{payload}</p>
                                    </div>
                                )}

                                <button
                                    type="button"
                                    onClick={(e) => history.push("/SignIn")}
                                    className="w-full bg-leaf text-offwhite py-2 px-4 rounded-md hover:bg-forest transition-colors duration-200 font-medium"
                                >
                                    Tillbaka
                                </button>

                                <div className="mt-8 pt-8 text-center w-full border-t border-sage">
                                <p className="text-sm text-brown">
                                    &copy; {new Date().getFullYear()} Naturborgarmärket
                                </p>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
};

export default ForgotPassword;